import Logo from "src/components/atoms/logo/Logo";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

import "./PageTop.scss";

const PageTop = () => {
  const onHomeClick = () => {
    ReactGA.event({
      category: "Navigation",
      action: "Home logo clicked",
    });
  };

  return (
    <div className="container">
      <div className="page-top">
        <Link to="/" onClick={onHomeClick}>
          <Logo greyscale={false} />
        </Link>
      </div>
    </div>
  );
};

export default PageTop;
